import { render, staticRenderFns } from "./CheckIcon.vue?vue&type=template&id=04050c44&scoped=true&"
import script from "./CheckIcon.vue?vue&type=script&lang=js&"
export * from "./CheckIcon.vue?vue&type=script&lang=js&"
import style0 from "./CheckIcon.vue?vue&type=style&index=0&id=04050c44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04050c44",
  null
  
)

export default component.exports